import { EventHandler } from "../../util/event/EventHandler";
import { ResultCode } from "../common/controller/net/constant/Constants";
import { SetTriggerRequest } from "../common/controller/net/request/SetTriggerRequest";
import { AbstractHandler } from "../core/handler/AbstractHandler";
import { SetTriggerResult } from "./SetTriggerResult";
/**
 * SetTriggerHandler.ts
 */
export class SetTriggerHandler extends AbstractHandler {
    constructor(parameters, action, scope) {
        super();
        this.parameters = parameters;
        this.eventHandler = new EventHandler(action, scope);
    }
    destroy() {
        super.destroy();
        this.parameters = null;
        this.eventHandler = null;
    }
    run() {
        super.run();
        this.send();
    }
    send() {
        let request = new SetTriggerRequest(this.parameters);
        request.onSuccess(this.handleSuccess, this);
        request.onFailure(this.handleFailed, this);
        request.send();
    }
    handleSuccess(data) {
        this.handleAction(new SetTriggerResult(ResultCode.SUCCESS, data));
    }
    handleFailed(data) {
        this.handleAction(new SetTriggerResult(data.getResponseCode()));
    }
    handleAction(result) {
        this.eventHandler.call(result);
        this.destroy();
    }
}
//# sourceMappingURL=SetTriggerHandler.js.map